module.exports = __webpack_public_path__ + "static/img/login_background_prod_mobile.b742bd55.png";